import { useEffect, useState } from "react";
import { Upload, Undo2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const IN = "w-full bg-slate-950 border border-slate-700 rounded px-2 py-1.5 text-xs text-white outline-none focus:ring-1 focus:ring-cyan-500";

export function PublishRelease() {
  const [rel, setRel] = useState(null);
  const [file, setFile] = useState(null);
  const [version, setVersion] = useState("");
  const [notes, setNotes] = useState("");
  const [pct, setPct] = useState(null);
  const load = () => api.get("/update/published").then((r) => setRel(r.data.release)).catch(() => {});
  useEffect(() => {
    load();
  }, []);
  const publish = async () => {
    if (!file || !version.trim()) { toast.error("Wybierz plik ZIP i wpisz wersję"); return; }
    const fd = new FormData();
    fd.append("file", file); fd.append("version", version.trim()); fd.append("notes", notes);
    setPct(0);
    try {
      const { data } = await api.post("/update/publish", fd, { timeout: 600000, onUploadProgress: (e) => e.total && setPct(Math.round((e.loaded / e.total) * 100)) });
      toast.success(`Opublikowano wersję ${data.version}`);
      if (data.warning) toast.warning(data.warning);
      setFile(null); setVersion(""); setNotes(""); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Publikacja nieudana"); }
    setPct(null);
  };
  const unpublish = async () => {
    if (!window.confirm("Cofnąć publikację? Klienci przestaną widzieć tę aktualizację.")) return;
    try { await api.delete("/update/published"); toast.success("Publikacja cofnięta"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="mt-3 border-t border-slate-700 pt-3" data-testid="publish-release">
      <div className="text-xs font-semibold text-emerald-300 mb-1">Publikuj aktualizację dla klientów</div>
      <p className="text-[11px] text-slate-400 mb-2">Wgrana tu paczka staje się wspólną aktualizacją dla wszystkich klientów. Klienci wykryją ją automatycznie (co 7 dni) i zainstalują przyciskiem »Aktualizuj teraz«.
        Dotyczy instalacji z paczki ZIP; klienci z obrazem Docker aktualizują się nowym obrazem.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <label className="md:col-span-1 inline-flex items-center gap-2 rounded bg-slate-700 hover:bg-slate-600 px-3 py-1.5 text-xs cursor-pointer truncate">
          <Upload size={13} /> <span className="truncate">{file ? file.name : "Wybierz fiberpass-full.zip"}</span>
          <input type="file" accept=".zip" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="publish-file-input" />
        </label>
        <input value={version} onChange={(e) => setVersion(e.target.value)} placeholder="Wersja, np. 1.9.16" className={IN} data-testid="publish-version" />
        <input value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Opis zmian" className={IN} data-testid="publish-notes" />
      </div>
      <button onClick={publish} disabled={pct !== null} className="mt-2 bg-emerald-700 hover:bg-emerald-600 disabled:opacity-50 rounded px-3 py-1.5 text-xs" data-testid="publish-submit">
        {pct !== null ? `Wgrywanie i weryfikacja podpisu… ${pct}%` : "Opublikuj"}
      </button>
      <div className="mt-2 text-[11px] text-slate-400" data-testid="publish-current">
        {rel ? (
          <span>Opublikowana: <b className="text-slate-200">v{rel.version}</b> · {(rel.published_at || "").slice(0, 16).replace("T", " ")} · {Math.round((rel.size || 0) / 104857.6) / 10} MB{rel.notes ? ` · ${rel.notes}` : ""}
            <button onClick={unpublish} className="ml-2 text-red-300 hover:text-red-200 inline-flex items-center gap-1" data-testid="publish-unpublish"><Undo2 size={12} /> Cofnij publikację</button>
          </span>
        ) : "Brak opublikowanej aktualizacji — klienci widzą wersję tego serwera."}
      </div>
    </div>
  );
}
